import React, { type PropsWithChildren } from 'react';
import { match } from 'ts-pattern';

type BadgeProps = PropsWithChildren<{
  direction?: 'rtl' | 'ltr';
  'data-testid'?: string;
  badge: React.ReactElement;
}>;

export const Badge = ({
  direction = 'rtl',
  badge,
  children,
  ...rest
}: BadgeProps) => (
  <div
    data-testid={rest['data-testid']}
    className="flex flex-row flex-nowrap items-center min-w-f0 line-clamp-1 truncate"
  >
    {match(direction)
      .with('rtl', () => (
        <>
          <div className="shrink-0">{badge}</div>
          {children}
        </>
      ))
      .with('ltr', () => (
        <>
          {children}
          <div className="shrink-0">{badge}</div>
        </>
      ))
      .otherwise(() => children)}
  </div>
);

export const InlineBadge = ({
  direction = 'rtl',
  badge,
  children,
}: BadgeProps) => (
  <span>
    {match(direction)
      .with('rtl', () => (
        <>
          <div className="inline-block">{badge}</div>
          {children}
        </>
      ))
      .with('ltr', () => (
        <>
          {children}
          {badge}
        </>
      ))
      .otherwise(() => children)}
  </span>
);
